import React from 'react';
import { Features } from '../../../../types/globalTypes';
import { FeatureCard } from './FeatureCard';
import styled from 'styled-components';
import { device } from '../../../../constants';

interface FeaturesContainerProps {
  data: Features[];
}

const FeaturesContainer: React.FC<FeaturesContainerProps> = ({ data }) => {
  return (
    <FeaturesWrapper>
      {data.map(feature => (
        <FeatureCard feature={feature} key={feature._id} />
      ))}
    </FeaturesWrapper>
  );
};
const FeaturesWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
  height: 100%;
  @media screen and ${device.md} {
    grid-template-columns: repeat(2, 1fr);
  }
`;
export { FeaturesContainer };
